export default "__VITE_ASSET__L7Z$66rB__"